import * as actionTypes from './actionTypes'
import { log } from 'util';

export const getMultiReportCardDeatils = (data) => {
    return {
        type: actionTypes.GET_MULTIPLE_REPORT_CARD_DETAILS,
        data
    }
}

export const getSingleReportCardsDetails = (data) => {
    return {
        type: actionTypes.GET_SINGLE_REPORT_CARD_DETAILS,
        data
    }
}
export const getMyStatisticsDetails = (data) => {
    return {
        type: actionTypes.GET_MY_STATISTICS_DETAILS,
        data
    }
}
export const setMyStatisticsDetails = (data) => {
    return {
        type: actionTypes.SET_MY_STATISTICS_DETAILS,
        data
    }
}
export const setMyStatTopHands = (data) => {
    return {
        type: actionTypes.SET_MY_STAT_TOP_HANDS,
        data
    }
}
export const setTopHands = (data) => {
    return {
        type: actionTypes.SET_TOP_HANDS,
        data
    }
}
export const setMyStatSettings = (data) => {
    return {
        type: actionTypes.SET_MY_STAT_SETTINGS,
        data
    }
}
export const getPlayerLevels = (data) => {
    return {
        type: actionTypes.GET_PLAYER_LEVELS,
        data
    }
}
export const setPlayerLevels = (data) => {
    return {
        type: actionTypes.SET_PLAYER_LEVELS,
        data
    }
}
export const getPlayerGameSubTypes = (data) => {
    return {
        type: actionTypes.GET_PLAYER_GAME_SUB_TYPES,
        data
    }
}
export const setPlayerGameSubTypes = (data) => {
    return {
        type: actionTypes.SET_PLAYER_GAME_SUB_TYPES,
        data
    }
}
export const getPlayerHitTypes = (data) => {
    return {
        type: actionTypes.GET_PLAYER_HIT_TYPES,
        data
    }
}
export const setPlayerHitTypes = (data) => {
    return {
        type: actionTypes.SET_PLAYER_HIT_TYPES,
        data
    }
}
export const getOnLoadReportCardDtls = (data) => {
    return {
        type: actionTypes.GET_ON_LOAD_REPORT_CARD_DETAILS,
        data
    }
}
export const setLevelInfo = (data) => {
    return {
        type: actionTypes.SET_LEVEL_INFO,
        data
    }
}

export const setReportCardSetting = (data) => {
    return {
        type: actionTypes.SET_REPORT_CARD_SETTING,
        data
    }
}

export const setMultiReportCardDeatils = (data) => {
    return {
        type: actionTypes.SET_REPORT_CARD_DETAILS,
        data
    }
}

export const setSingleReportCardDeatils = (data) => {
    return {
        type: actionTypes.SET_SINGLE_REPORT_CARD_DETAILS,
        data
    }
}

export const setGameType = (data) => {
    return {
        type: actionTypes.SET_GAME_TYPE,
        data
    }
}

export const setRange = (data) => {
    return {
        type: actionTypes.SET_RANGE,
        data
    }
}

export const setType = (data) => {
    return {
        type: actionTypes.SET_LEVEL,
        data
    }
}
export const setMissions = (data) => {
    return {
        type: actionTypes.SET_MISSIONS,
        data
    }
}

export const getMissions = (data) => {
    return {
        type: actionTypes.GET_MISSIONS,
        data
    }
}
export const setPromotionalContent = (data) => {
    return {
        type: actionTypes.SET_PROMOTIONAL_CONTENT,
        data
    }
}
export const toggleTournamentHistoryDetails = (data) => {
    return {
        type: actionTypes.TOGGLE_TOURNAMENT_HISTORY_DETAILS,
        data
    }
}
export const toggleTournamentHistoryFullScreen = (data) => {
    return {
        type: actionTypes.TOGGLE_TOURNAMENT_HISTORY_FULL_SCREEN,
        data
    }
}

export const setTournyFilter = (data) => {
    return {
        type: actionTypes.SET_TOURNY_FILTER,
        data
    }
}


/** WEBPACK FOOTER **
 ** ./src/store/actions/multipleReportCardsAction.js
 **/